import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { Axios } from "axios";
import { useAxios } from "@packsize/authentication";

import { getFavoriteDesigns } from "@/api/packaging-design-api";

export type UserFavoriteDesigns = Record<string, boolean>;

export const USER_FAVORITE_DESIGNS_QUERY_KEY = "user-favorite-designs" as const;

const fetchUserFavoriteDesigns = async (client: Axios): Promise<UserFavoriteDesigns> => {
	const data = await getFavoriteDesigns(client);
	return Object.fromEntries(data.map((d) => [d, true]));
};

type UseUserFavoriteDesignsQueryOptions = Omit<
	UseQueryOptions<UserFavoriteDesigns, Error, UserFavoriteDesigns>,
	"queryKey" | "queryFn"
>;

export const useUserFavoriteDesigns = (queryConfig: UseUserFavoriteDesignsQueryOptions = {}) => {
	const client = useAxios();
	const query = useQuery({
		queryKey: [client, USER_FAVORITE_DESIGNS_QUERY_KEY],
		queryFn: () => fetchUserFavoriteDesigns(client),
		...queryConfig,
	});

	return {
		userFavoriteDesigns: query.data ?? {},
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};
